import axios from "axios";
import { isTokenValid } from "./authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor para agregar token si lo necesitas
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token && isTokenValid(token)) {
    const cleanToken = token.replace(/^Bearer\s+/i, "").trim();
    config.headers.Authorization = `Bearer ${cleanToken}`;
  } else if (token && !isTokenValid(token)) {
    localStorage.removeItem("token");
    window.location.href = "/";
  }

  return config;
});

export default api;
